module.exports = __webpack_public_path__ + "img/270.0b13ef88.jpg";